import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Grid, AppBar, Toolbar, Typography, Link } from '@mui/material';
import { VideoLibrary } from '@mui/icons-material';
import FileExplorer from './components/FileExplorer';
import VideoPlayer from './components/VideoPlayer';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

function App() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoSelect = (video) => {
    if (!video.directory) {
      setSelectedVideo(video);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <AppBar position="static">
          <Toolbar>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
              <Box>
                <Link href="/" color="inherit" underline="none" sx={{ display: 'flex', alignItems: 'center' }}>
                  <VideoLibrary sx={{ mr: 2 }} />
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    Video Explorer
                  </Typography>
                </Link>
              </Box>
              <Box component="span" sx={{ marginLeft: 'auto' }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  Made with<span>❤️‍🔥</span>by @khil😎
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>

        <Box sx={{ flex: 1, p: 2, overflow: 'hidden' }}>
          <Grid container spacing={2} sx={{ height: '100%' }}>
            {!selectedVideo ?
              <Grid item size={12} sx={{ height: '100%' }}>
                <FileExplorer onVideoSelect={handleVideoSelect} />
              </Grid>
              :
              <Grid item size={12} sx={{ height: '100%' }}>
                <VideoPlayer video={selectedVideo} />
              </Grid>
            }
          </Grid>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;